/* ==========================================================================
   OUTLYRS CLUB — facets.js
   Collection filtering & sorting via native storefront filters (form GET reload)
   + mobile filter drawer. Reliable, accessible, no framework.
   ========================================================================== */
(function () {
  "use strict";

  function init() {
    var form = document.querySelector("[data-facets-form]");
    if (!form) return;
    var isDesktop = function () { return window.matchMedia("(min-width: 1000px)").matches; };

    // Sort always auto-submits
    var sort = form.querySelector("[data-sort]");
    if (sort) sort.addEventListener("change", function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

    // Filter inputs auto-submit on desktop only (mobile uses Apply button)
    form.querySelectorAll("[data-facet-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        if (isDesktop() && input.type === "checkbox") { form.requestSubmit ? form.requestSubmit() : form.submit(); }
      });
    });

    // Filter drawer (overlay + backdrop; every [data-facets-close] closes it)
    var panel = form.querySelector("[data-facets]");
    var openBtn = form.querySelector("[data-facets-open]");
    var closeBtns = form.querySelectorAll("[data-facets-close]");
    if (panel && openBtn) {
      var open = function () {
        panel.classList.add("is-open");
        document.body.classList.add("is-locked");
        document.addEventListener("keydown", onKey);
        var f = panel.querySelector(".facets__panel input, .facets__panel button, .facets__panel a[href]");
        if (f) f.focus();
      };
      var close = function () {
        panel.classList.remove("is-open");
        document.body.classList.remove("is-locked");
        document.removeEventListener("keydown", onKey);
        openBtn.focus();
      };
      var onKey = function (e) {
        if (e.key === "Escape") close();
        else if (e.key === "Tab" && window.Outlyrs && window.Outlyrs.trapFocus) window.Outlyrs.trapFocus(panel, e);
      };
      openBtn.addEventListener("click", open);
      closeBtns.forEach(function (b) { b.addEventListener("click", close); });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
